import { UserConfigKey } from '../../shared/constants';

export const ALL_NOTIFICATIONS_ENABLED_CONFIG: Array<{
  key: UserConfigKey;
  value: string;
}> = [
  { key: UserConfigKey.notificationsSystemPushEnabled, value: 'true' },
  { key: UserConfigKey.notificationsSocialPushEnabled, value: 'true' },
  { key: UserConfigKey.notificationsMarketingPushEnabled, value: 'true' },
  { key: UserConfigKey.notificationsRemindersPushEnabled, value: 'true' },
];
